let Lang = {
  details: {
    ENG: '<div class="in">ENTER YOUR DETAILS</div>',
    ARB: '<div class="in">قم بإدخال بياناتك</div>',
  },
  tc: {
    ENG: 'I accept and understand the Kellanova <u>Privacy Policy.</u>',
    ARB: 'أقر بموافقتي وفهمي <u>لسياسة الخصوصية</u> الخاصة بشركة Kellanova',
  },
  privacy: {
    ENG: 'I agree to receive updates on similar promotions, products, and other marketing communications from Kellanova.',
    ARB: 'أوافق على استلام التحديثات والعروض الترويجية والمنتجات والمراسلات التسويقية المشابهة من شركة Kellanova',
  },
  start: {
    ENG: 'START',
    ARB: 'ابدأ',
  },
  name: {
    ENG: 'NAME',
    ARB: 'الاسم',
  },
  email: {
    ENG: 'EMAIL',
    ARB: 'البريد الإلكتروني ',
  },
  country: {
    ENG: 'COUNTRY',
    ARB: 'البلد',
  },
  mobile: {
    ENG: 'PHONE NUMBER',
    ARB: 'رقم الهاتف',
  },
  next: {
    ENG: 'NEXT',
    ARB: 'التالي',
  },
  uploadPhoto: {
    ENG: '<div class="in">UPLOAD YOUR PHOTO</div>',
    ARB: '<div class="in">أضف صورتك</div>',
  },
  upload: {
    ENG: 'UPLOAD',
    ARB: 'تحميل',
  },
  skip: {
    ENG: '<div class="in">SKIP</div>',
    ARB: '<div class="in">تخطي</div>',
  },
  pinch: {
    ENG: 'PINCH TO ZOOM AND ADJUST IMAGE',
    ARB: 'كبر الصورة وضبطها باللمس',
  },
  choose: {
    ENG: '<div class="in">CHOOSE YOUR CHARACTER</div>',
    ARB: '<div class="in">اختر شخصيتك</div>',
  },
  play: {
    ENG: 'PLAY',
    ARB: 'العب',
  },
  how: {
    ENG: '<div class="in">HOW TO PLAY?</div>',
    ARB: '<div class="in">كيفية اللعب</div>',
  },

  use: {
    ENG: '<div class="in">USE THE JOYSTICK TO MOVE<br> THE CHARACTER.</div>',
    ARB: '<div class="in">استخدم عصا التحكم لتوجيه الشخصية</div>',
  },
  avoid: {
    ENG: '<div class="in">AVOID THE CARS ON THE ROAD.</div>',
    ARB: '<div class="in">تجنب المركبات على الطريق</div>',
  },
  collect: {
    ENG: '<div class="in">COLLECT PRINGLES PACKS<br> EACH PACK GIVES YOU 1 POINT.</div>',
    ARB:
      '<div class="in">جمّع عبوات برينجلز' +
      '<br>كل عبوة تمنحك نقطة واحدة</div>',
  },
  have: {
    ENG: '<div class="in">YOU HAVE 45 SECONDS TO<br> SCORE AS MUCH AS YOU CAN!</div>',
    ARB: '<div class="in">لديك ٤٥ ثانية لحصد أكبر عدد من النقاط</div>',
  },
  congrats: {
    ENG: '<div class="in">CONGRATULATIONS!</div>',
    ARB: '<div class="in">تهانينا!</div>',
  },
  yourScore: {
    ENG: '<div class="in">YOUR SCORE</div>',
    ARB: '<div class="in">نقاطك</div>',
  },
  tryAgain: {
    ENG: 'TRY AGAIN',
    ARB: 'أعد المحاولة',
  },
  share: {
    ENG: 'SHARE',
    ARB: ' أرسل',
  },
  leaderboard: {
    ENG: 'LEADERBOARD',
    ARB: 'لوحة المتصدرين',
  },
  rank: {
    ENG: 'RANK',
    ARB: 'رتبة',
  },

  score: {
    ENG: 'SCORE',
    ARB: 'نتيجة',
  },
  userImage: {
    ENG: 'SELECT IMAGE TO UPLOAD',
    ARB: 'حدد الصورة للتحميل',
  },
  errorName: {
    ENG: 'Please enter name',
    ARB: 'الرجاء إدخال الاسم',
  },
  errorEmail: {
    ENG: 'Please enter email',
    ARB: 'الرجاء إدخال البريد الإلكتروني',
  },
  errorCountry: {
    ENG: 'Please select country',
    ARB: 'الرجاء اختيار البلد',
  },
  errorMobile: {
    ENG: 'Please enter phone number',
    ARB: 'الرجاء إدخال رقم الهاتف',
  },
  introTap: {
    ENG: 'Tap to run.',
    ARB: 'انقر للتشغيل.',
  },
  introSwipe: {
    ENG: 'Swipe to Turn.',
    ARB: 'اسحب الشاشة للتحريك.',
  },
};
export { Lang };
